import { useHistory } from "react-router-dom";
export default function useCallBackUrl(param: string) {
  const history = useHistory();
  const queryParams = new URLSearchParams(history.location.search);
  const callbackQuery = queryParams.get(param)?.toString() !== undefined ? `?${param}=${queryParams.get(param)?.toString()}`:``;
  const callbackValue = queryParams.get(param)?.toString() !== undefined ? `${queryParams.get(param)?.toString()}`:``;
  return [callbackQuery, callbackValue];
}
